import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
	A_SS_Campaign,
	A_SS_Inventory,
	A_SS_KOL,
	A_SS_Patient,
	A_SS_Rostering,
	A_SS_Session,
	I_SS_Inventory,
	I_SS_KOL,
	I_SS_Patient,
	I_SS_Rostering,
	I_SS_Session,
	I_SS_Campaign,
	I_SS_NoteTaking,
	A_SS_Promo,
	I_SS_Promo,
	I_SS_Billing,
	A_SS_DataTable,
	I_SS_DataTable,
	A_SS_CustomizedReport,
	I_SS_CustomizedReport,
	I_SS_Appointment,
} from "../../../assets/images";

const subMenuList = Object.freeze({
	APPOINTMENT: "appointment",
	MAILCHIMP: "mailchimp",
});
function SidebarStaff({ sidebar, setSidebar }) {
	const [activePage, setActivePage] = useState();
	const [noteTaking, setNoteTaking] = useState(false);
	const [billing, setBilling] = useState(false);
	const [inventory, setInventory] = useState(false);
	const [subMenu, setSubMenu] = useState({
		appointment: false,
		mailchimp: false,
	});

	const userData = useSelector((state) => state.userData.value);

	const handleSubMenu = (toOpen, value) => {
		setSubMenu({
			...subMenu,
			appointment: toOpen === subMenuList.APPOINTMENT ? value : false,
			mailchimp: toOpen === subMenuList.MAILCHIMP ? value : false,
		});
	};

	window.addEventListener("click", function (e) {
		if (
			document.getElementById("clickbox")?.contains(e.target) ||
			document.getElementById("toggler")?.contains(e.target)
		) {
		} else {
			let width =
				window.innerWidth > 0 ? window.innerWidth : window.screen.width;
			if (width < 820) {
				setSidebar(false);
			}
		}
	});

	return (
		<div
			id="clickbox"
			className={`custom-scroll sideBar ${
				sidebar ? "openSidebar" : "closeSidebar"
			}`}
		>
			<ul style={{ paddingBottom: 150 }}>
				{/* <Link
          to="/questions"
          onClick={() => {
            setActivePage("/questions");
            setNoteTaking();
          }}
        >
          <li className={activePage === "/questions" ? "active" : ""}>
            <i className="fa-solid fa-user"></i>
            Questionnaire Popup
          </li>
        </Link> */}
				{userData?.department?.permissions?.find(
					(e) => e.moduleName === "Rostering",
				) && (
					<Link
						to="/rostering"
						onClick={() => {
							setActivePage("/rostering");
							setNoteTaking();
							setBilling();
							setInventory();
						}}
					>
						<li
							className={
								activePage === "/rostering" ? "active" : ""
							}
						>
							{activePage === "/rostering" ? (
								<img
									alt=""
									src={A_SS_Rostering}
									className="me-3"
								/>
							) : (
								<img
									alt=""
									src={I_SS_Rostering}
									className="me-3"
								/>
							)}
							Dashboard
						</li>
					</Link>
				)}
				{userData?.department?.permissions?.find(
					(e) => e.moduleName === "Appointment",
				) && (
					<>
						<div
							onClick={() => {
								setActivePage("/appointment");
								// handleSubMenu(subMenuList.APPOINTMENT, true);
								setBilling();
								setInventory();
							}}
						>
							<div className="sidebarExtend">
								<div className="w-100">
									<div
										className={`d-flex align-items-center px-3 py-3 ${
											noteTaking && "pb-0"
										} pt-3`}
										onClick={() => {
											handleSubMenu(
												subMenuList.APPOINTMENT,
												!subMenu.appointment,
											);
											setBilling();
											setInventory();
											setNoteTaking();
											console.log(subMenu);
										}}
									>
										<img
											alt=""
											src={I_SS_Appointment}
											className="me-3"
										/>
										Appointment
										<div className="ms-auto">
											{subMenu.appointment ? (
												<i class="fa-solid fa-angle-up"></i>
											) : (
												<i class="fa-solid fa-angle-down"></i>
											)}
										</div>
									</div>
									{subMenu.appointment && (
										<div className="py-1 my-2 gray-background">
											<Link
												to="/appointments"
												onClick={() =>
													handleSubMenu(
														subMenuList.APPOINTMENT,
														"appointments",
													)
												}
											>
												<div
													className={`sidebar-subcategory ps-5 py-2 ${
														subMenu.appointment ===
														"appointments"
															? "white-background"
															: "gray-font"
													}`}
												>
													Appointments
												</div>
											</Link>
											<Link
												to="/appointment-reminder"
												onClick={() =>
													handleSubMenu(
														subMenuList.APPOINTMENT,
														"appointment-reminder",
													)
												}
											>
												<div
													className={`sidebar-subcategory ps-5 py-2 ${
														subMenu.appointment ===
														"appointment-reminder"
															? "white-background"
															: "gray-font"
													}`}
												>
													Appointment Reminder
												</div>
											</Link>
											<Link
												to="/waiting-list"
												onClick={() =>
													handleSubMenu(
														subMenuList.APPOINTMENT,
														"waiting-list",
													)
												}
											>
												<div
													className={`sidebar-subcategory ps-5 py-2 ${
														subMenu.appointment ===
														"waiting-list"
															? "white-background"
															: "gray-font"
													}`}
												>
													Waiting List
												</div>
											</Link>
											{/* <Link
										to='/patient-sms-reminder'
										onClick={() =>
											handleSubMenu(
												subMenuList.APPOINTMENT,
												"patient-sms-reminder",
											)
										}
									>
										<div
											className={`sidebar-subcategory ps-5 py-2 ${
												subMenu.appointment === "patient-sms-reminder"
													? "white-background"
													: "gray-font"
											}`}
										>
											Patient SMS Reminder
										</div>
									</Link>
									<Link
										to='/sms'
										onClick={() =>
											handleSubMenu(subMenuList.APPOINTMENT, "sms")
										}
									>
										<div
											className={`sidebar-subcategory ps-5 py-2 ${
												subMenu.appointment === "sms"
													? "white-background"
													: "gray-font"
											}`}
										>
											SMS
										</div>
									</Link> */}
										</div>
									)}
								</div>
							</div>
						</div>
					</>
				)}
				{/* {userData?.department?.permissions?.find((e) => e.moduleName === "Note-Taking") && ( */}

				{userData?.department?.permissions?.find(
					(e) => e.moduleName === "Session",
				) && (
					<Link
						to="/session"
						onClick={() => {
							setActivePage("/session");
							handleSubMenu(subMenuList.APPOINTMENT, false);
							setNoteTaking();
							setBilling();
							setInventory();
						}}
					>
						<li
							className={
								activePage === "/session" ? "active" : ""
							}
						>
							{activePage === "/session" ? (
								<img
									alt=""
									src={A_SS_Session}
									className="me-3"
								/>
							) : (
								<img
									alt=""
									src={I_SS_Session}
									className="me-3"
								/>
							)}
							Session
						</li>
					</Link>
				)}

				{userData?.department?.permissions?.find(
					(e) => e.moduleName === "Inventory",
				) && (
					<div
						onClick={() => {
							setActivePage("/uom-inventory");
							handleSubMenu(subMenuList.APPOINTMENT, false);
							setNoteTaking();
							setBilling();
						}}
					>
						<div className="sidebarExtend">
							<div className="w-100">
								<div
									className={`d-flex align-items-center px-3 py-3 ${
										inventory && "pb-0"
									} pt-3`}
									onClick={() => {
										setInventory(inventory ? null : "i");
									}}
								>
									<img
										alt=""
										src={I_SS_Inventory}
										className="me-3"
									/>
									Inventory
									<div className="ms-auto">
										{inventory ? (
											<i class="fa-solid fa-angle-up"></i>
										) : (
											<i class="fa-solid fa-angle-down"></i>
										)}
									</div>
								</div>
								{inventory && (
									<div className="py-1 my-2 gray-background">
										<Link
											to="/inventory-products"
											onClick={() =>
												setInventory("Products")
											}
										>
											<div
												className={`sidebar-subcategory ps-5 py-2 ${
													inventory === "Products"
														? "white-background"
														: "gray-font"
												}`}
											>
												Products
											</div>
										</Link>
										<Link
											to="/packages"
											onClick={() =>
												setInventory("Packages")
											}
										>
											<div
												className={`sidebar-subcategory ps-5 py-2 ${
													inventory === "Packages"
														? "white-background"
														: "gray-font"
												}`}
											>
												Packages
											</div>
										</Link>
										<Link
											to="/inventory-treatments"
											onClick={() =>
												setInventory("Treatments")
											}
										>
											<div
												className={`sidebar-subcategory ps-5 py-2 ${
													inventory === "Treatments"
														? "white-background"
														: "gray-font"
												}`}
											>
												Treatments
											</div>
										</Link>
										<Link
											to="/adjustment-stock"
											onClick={() =>
												setInventory("Adjustment")
											}
										>
											<div
												className={`sidebar-subcategory ps-5 py-2 ${
													inventory === "Adjustment"
														? "white-background"
														: "gray-font"
												}`}
											>
												Adjustment Stock
											</div>
										</Link>
										<Link
											to="/purchase-list"
											onClick={() =>
												setInventory("Purchase")
											}
										>
											<div
												className={`sidebar-subcategory ps-5 py-2 ${
													inventory === "Purchase"
														? "white-background"
														: "gray-font"
												}`}
											>
												Purchase List
											</div>
										</Link>
										<Link
											to="/receiving-goods"
											onClick={() =>
												setInventory("Receive")
											}
										>
											<div
												className={`sidebar-subcategory ps-5 py-2 ${
													inventory === "Receive"
														? "white-background"
														: "gray-font"
												}`}
											>
												Receiving Goods
											</div>
										</Link>
									</div>
								)}
							</div>
						</div>
					</div>
				)}

				{/* {userData?.department?.permissions?.find(
          (e) => e.moduleName === "Inventory"
        ) && (
          <Link
            to="/uom-inventory"
            onClick={() => {
              setActivePage("/uom-inventory");
              setNoteTaking();
              setBilling();
            }}
          >
            <li className={activePage === "/uom-inventory" ? "active" : ""}>
              {activePage === "/uom-inventory" ? (
                <img alt="" src={A_SS_Inventory} className="me-3" />
              ) : (
                <img alt="" src={I_SS_Inventory} className="me-3" />
              )}
              Inventory
            </li>
          </Link>
        )} */}

				{userData?.department?.permissions?.find(
					(e) => e.moduleName === "Patient",
				) && (
					<Link
						to="/patient"
						onClick={() => {
							setActivePage("/patient");
							handleSubMenu(subMenuList.APPOINTMENT, false);
							setNoteTaking();
							setBilling();
							setInventory();
						}}
					>
						<li
							className={
								activePage === "/patient" ||
								activePage === "/add-patient"
									? "active"
									: ""
							}
						>
							{activePage === "/patient" ? (
								<img
									alt=""
									src={A_SS_Patient}
									className="me-3"
								/>
							) : (
								<img
									alt=""
									src={I_SS_Patient}
									className="me-3"
								/>
							)}
							Patient
						</li>
					</Link>
				)}

				{userData?.department?.permissions?.find(
					(e) => e.moduleName === "KOL/Channel",
				) && (
					<Link
						to="/kol"
						onClick={() => {
							setActivePage("/kol");
							handleSubMenu(subMenuList.APPOINTMENT, false);
							setNoteTaking();
							setBilling();
							setInventory();
						}}
					>
						<li className={activePage === "/kol" ? "active" : ""}>
							{activePage === "/kol" ? (
								<img alt="" src={A_SS_KOL} className="me-3" />
							) : (
								<img alt="" src={I_SS_KOL} className="me-3" />
							)}
							KOL/Channel
						</li>
					</Link>
				)}

				{/* {userData?.department?.permissions?.find(
					(e) => e.moduleName === "Campaign",
				) && (
					<Link
						to="/campaign"
						onClick={() => {
							setActivePage("/campaign");
							handleSubMenu(subMenuList.APPOINTMENT, false);
							setNoteTaking();
							setBilling();
							setInventory();
						}}
					>
						<li
							className={
								activePage === "/campaign" ? "active" : ""
							}
						>
							{activePage === "/campaign" ? (
								<img
									alt=""
									src={A_SS_Campaign}
									className="me-3"
								/>
							) : (
								<img
									alt=""
									src={I_SS_Campaign}
									className="me-3"
								/>
							)}
							Campaign
						</li>
					</Link>
				)} */}

				{userData?.department?.permissions?.find(
					(e) => e.moduleName === "Note-Taking",
				) && (
					<div
						onClick={() => {
							setActivePage("/note-taking");
							handleSubMenu(subMenuList.APPOINTMENT, false);
							setBilling();
							setInventory();
						}}
					>
						<div className="sidebarExtend">
							<div className="w-100">
								<div
									className={`d-flex align-items-center px-3 py-3 ${
										noteTaking && "pb-0"
									} pt-3`}
									onClick={() => {
										setNoteTaking(noteTaking ? null : "d");
									}}
								>
									<img
										alt=""
										src={I_SS_NoteTaking}
										className="me-3"
									/>
									Note Taking
									<div className="ms-auto">
										{noteTaking ? (
											<i class="fa-solid fa-angle-up"></i>
										) : (
											<i class="fa-solid fa-angle-down"></i>
										)}
									</div>
								</div>
								{noteTaking && (
									<div className="py-1 my-2 gray-background">
										<Link
											to="/doctor-notes"
											onClick={() =>
												setNoteTaking("doctor")
											}
										>
											<div
												className={`sidebar-subcategory ps-5 py-2 ${
													noteTaking === "doctor"
														? "white-background"
														: "gray-font"
												}`}
											>
												Doctor
											</div>
										</Link>
										<Link
											to="/therapist-notes"
											onClick={() =>
												setNoteTaking("therapist")
											}
										>
											<div
												className={`sidebar-subcategory ps-5 py-2 ${
													noteTaking === "therapist"
														? "white-background"
														: "gray-font"
												}`}
											>
												Therapist
											</div>
										</Link>
										<Link
											to="/nutritionist-notes"
											onClick={() =>
												setNoteTaking("nutritionist")
											}
										>
											<div
												className={`sidebar-subcategory ps-5 py-2 ${
													noteTaking === "nutritionist"
														? "white-background"
														: "gray-font"
												}`}
											>
												Nutritionist
											</div>
										</Link>
										{/* <Link
											to="/patient-notes"
											onClick={() =>
												setNoteTaking("patient")
											}
										>
											<div
												className={`sidebar-subcategory ps-5 py-2 ${
													noteTaking === "patient"
														? "white-background"
														: "gray-font"
												}`}
											>
												Nutritionist
											</div>
										</Link> */}
									</div>
								)}
							</div>
						</div>
					</div>
				)}

				{userData?.department?.permissions?.find(
					(e) => e.moduleName === "Promo",
				) && (
					<Link
						to="/promo"
						onClick={() => {
							setActivePage("/promo");
							handleSubMenu(subMenuList.APPOINTMENT, false);
							setNoteTaking();
							setBilling();
							setInventory();
						}}
					>
						<li className={activePage === "/promo" ? "active" : ""}>
							{activePage === "/promo" ? (
								<img alt="" src={A_SS_Promo} className="me-3" />
							) : (
								<img alt="" src={I_SS_Promo} className="me-3" />
							)}
							Promo
						</li>
					</Link>
				)}

				{userData?.department?.permissions?.find(
					(e) => e.moduleName === "Billing",
				) && (
					<div
						onClick={() => {
							setActivePage("/billing");
							handleSubMenu(subMenuList.APPOINTMENT, false);
							setNoteTaking();
							setInventory();
						}}
					>
						<div className="sidebarExtend">
							<div className="w-100">
								<div
									className={`d-flex align-items-center px-3 py-3 ${
										billing && "pb-0"
									} pt-3`}
									onClick={() => {
										setBilling(billing ? null : "b");
									}}
								>
									<img
										alt=""
										src={I_SS_Billing}
										className="me-3"
									/>
									Billing
									<div className="ms-auto">
										{billing ? (
											<i class="fa-solid fa-angle-up"></i>
										) : (
											<i class="fa-solid fa-angle-down"></i>
										)}
									</div>
								</div>
								{billing && (
									<div className="py-1 my-2 gray-background">
										<Link
											to="/billing"
											onClick={() =>
												setBilling("listBilling")
											}
										>
											<div
												className={`sidebar-subcategory ps-5 py-2 ${
													billing === "listBilling"
														? "white-background"
														: "gray-font"
												}`}
											>
												List Billing
											</div>
										</Link>
										<Link
											to="/refund"
											onClick={() => setBilling("Refund")}
										>
											<div
												className={`sidebar-subcategory ps-5 py-2 ${
													billing === "Refund"
														? "white-background"
														: "gray-font"
												}`}
											>
												Refund
											</div>
										</Link>
									</div>
								)}
							</div>
						</div>
					</div>
				)}

				{userData?.department?.permissions?.find(
					(e) => e.moduleName === "Data Table Generation",
				) && (
					<Link
						to="/data-table"
						onClick={() => {
							setActivePage("/data-table");
							handleSubMenu(subMenuList.APPOINTMENT, false);
							setNoteTaking();
							setBilling();
							setInventory();
						}}
					>
						<li
							className={
								activePage === "/data-table" ? "active" : ""
							}
						>
							{activePage === "/data-table" ? (
								<img
									alt=""
									src={A_SS_DataTable}
									className="me-3"
								/>
							) : (
								<img
									alt=""
									src={I_SS_DataTable}
									className="me-3"
								/>
							)}
							Data Table Generation
						</li>
					</Link>
				)}

				{/* <Link
          to="/testing-drawtool"
          onClick={() => {
            setActivePage("/data-table");
            setNoteTaking();
            setBilling();
          }}
        >
          <li className={activePage === "/data-table" ? "active" : ""}>
            {activePage === "/data-table" ? (
              <img alt="" src={A_SS_DataTable} className="me-3" />
            ) : (
              <img alt="" src={I_SS_DataTable} className="me-3" />
            )}
            Testing - Drawtool
          </li>
        </Link> */}

				{userData?.department?.permissions?.find(
					(e) => e.moduleName === "Customized Reports",
				) && (
					<Link
						to="/customized-reports"
						onClick={() => {
							setActivePage("/customized-reports");
							setNoteTaking();
							handleSubMenu(subMenuList.APPOINTMENT, false);
							setInventory();
							setBilling();
						}}
					>
						<li
							className={
								activePage === "/customized-reports"
									? "active"
									: ""
							}
						>
							{activePage === "/customized-reports" ? (
								<img
									alt=""
									src={A_SS_CustomizedReport}
									className="me-3"
								/>
							) : (
								<img
									alt=""
									src={I_SS_CustomizedReport}
									className="me-3"
								/>
							)}
							Customized Reports
						</li>
					</Link>
				)}
				{/* {userData?.department?.permissions?.find(
					(e) => e.moduleName === "Mail Chimp",
				) && (
					<>
						<div
							onClick={() => {
								setActivePage("/appointment");
								// handleSubMenu(subMenuList.APPOINTMENT, true);
								setBilling();
								setInventory();
							}}
						>
							<div className="sidebarExtend">
								<div className="w-100">
									<div
										className={`d-flex align-items-center px-3 py-3 ${
											noteTaking && "pb-0"
										} pt-3`}
										onClick={() => {
											handleSubMenu(
												subMenuList.MAILCHIMP,
												!subMenu.mailchimp,
											);
											setBilling();
											setInventory();
											setNoteTaking();
										}}
									>
										<img
											alt=""
											src={I_SS_Rostering}
											className="me-3"
										/>
										Mailchimp
										<div className="ms-auto">
											{subMenu.appointment ? (
												<i class="fa-solid fa-angle-up"></i>
											) : (
												<i class="fa-solid fa-angle-down"></i>
											)}
										</div>
									</div>
									{subMenu.mailchimp && (
										<div className="py-1 my-2 gray-background">
											<Link
												to="/create-templates"
												onClick={() =>
													handleSubMenu(
														subMenuList.MAILCHIMP,
														"email-templates",
													)
												}
											>
												<div
													className={`sidebar-subcategory ps-5 py-2 ${
														subMenu.mailchimp ===
														"email-templates"
															? "white-background"
															: "gray-font"
													}`}
												>
													Create Templates
												</div>
											</Link>
											<Link
												to="/send-mail"
												onClick={() =>
													handleSubMenu(
														subMenuList.MAILCHIMP,
														"mail-campaigns",
													)
												}
											>
												<div
													className={`sidebar-subcategory ps-5 py-2 ${
														subMenu.mailchimp ===
														"mail-campaigns"
															? "white-background"
															: "gray-font"
													}`}
												>
													Send Mail
												</div>
											</Link>
										</div>
									)}
								</div>
							</div>
						</div>
					</>
				)} */}

				{/* {userData?.department?.permissions?.find(
					(e) => e.moduleName === "Settings",
				) && (
					<Link
						to="/staff-settings"
						onClick={() => {
							setActivePage("/staff-settings");
							handleSubMenu(subMenuList.APPOINTMENT, false);
							setNoteTaking();
							setInventory();
							setBilling();
						}}
					>
						<li
							className={
								activePage === "/staff-settings" ? "active" : ""
							}
						>
							<i class="fa-solid fa-gear"></i>
							Settings
						</li>
					</Link>
				)} */}

				{/* <Link
					to="/draw-tool"
					onClick={() => {
						setActivePage("/draw-tool");
						handleSubMenu(subMenuList.APPOINTMENT, false);
						setNoteTaking();
						setInventory();
						setBilling();
					}}
				>
					<li className={activePage === "/draw-tool" ? "active" : ""}>
						<i class="fa-solid fa-gear"></i>
						Drawtool - Testing
					</li>
				</Link> */}
			</ul>
		</div>
	);
}

export default SidebarStaff;
